import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { CareTeamListScreen } from 'screens/care-team';

export default withPermissions(CareTeamListScreen, [
  GroupSecurity.CareTeamRead,
]);
